import Vacancies from './vacancies';

export const vacancies = {
  firstLevel: Vacancies,
};